import { render, staticRenderFns } from "./shopData.vue?vue&type=template&id=2849d98f&scoped=true&"
import script from "./shopData.vue?vue&type=script&lang=js&"
export * from "./shopData.vue?vue&type=script&lang=js&"
import style0 from "./shopData.vue?vue&type=style&index=0&id=2849d98f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2849d98f",
  null
  
)

export default component.exports